<template>
    <div class="help-container">
      <h2 class="help-title">Ayuda para la Gestión de Usuarios</h2>
      <p class="help-introduction">
        Esta sección proporciona asistencia para la administración de usuarios dentro del sistema. Aquí podrás realizar varias operaciones relacionadas con la gestión de cuentas de usuarios.
      </p>
      <ul class="help-list">
        <li><strong>Buscar por ID:</strong> Ingresa el ID del usuario para buscar un registro específico.</li>
        <li><strong>Buscar por Nombre:</strong> Escribe el nombre del usuario para filtrar la búsqueda según este criterio.</li>
        <li><strong>Visualizar Información:</strong> Puedes ver la información detallada de cada usuario al seleccionar la opción correspondiente en el menú de acciones.</li>
        <li><strong>Editar Permisos:</strong> Modifica los permisos de acceso de los usuarios para ajustar su nivel de interacción con el sistema.</li>
        <li><strong>Activar/Desactivar Usuarios:</strong> Activa o desactiva cuentas de usuarios para controlar su acceso al sistema.</li>
        <li><strong>Añadir Nuevo Usuario:</strong> Completa el formulario de registro para añadir nuevos usuarios al sistema.</li>
        <li><strong>Eliminar Usuario:</strong> Elimina cuentas de usuario que ya no son necesarias o pertinentes.</li>
      </ul>
      <p class="help-conclusion">
        Mantén la información de los usuarios actualizada y precisa para asegurar una gestión eficiente de los mismos dentro del sistema.
      </p>
    </div>
  </template>
  <script>
  export default {
    name: "AyudaUsuario",
  };
  </script>
<style src="@/assets/css/ayuda.css" scoped></style>
  